//引入外部模組
import {checkDevice} from '@/common';
import {BodyCtrl} from '@/body_ctrl';




//引入外部模組
let bodyCtrl = new BodyCtrl;




//讀取頁面
class Preloader {
  constructor() {
    this.preloader = $('#preloader');
    this.logo      = this.preloader.find('.icon');
    this.time      = 500;
  }
  loading() {
    /*
    (checkDevice.ios || checkDevice.android) ? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
    this.logo.addClass('active');
    $(window).on('load', () => {
      setTimeout(() => {
        this.logo.removeClass('active');
        this.preloader.addClass('active');
        bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
        bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
      }, this.time);
    });
    */
    this.logo.removeClass('active');
    this.preloader.addClass('active');
  }
}




//輸出
export {Preloader};


// WEBPACK FOOTER //
// ./js_new/preloader.js